<template>
   <div>
      <div class="card">
         <div class="card-header">
            <h4 v-if="router.currentRoute._value.params.id">Alterar Timbre</h4>
            <h4 v-else>Criar Timbre</h4>
         </div>
         <div class="card-body">
            <div class="row">
               <div class="col-md-4">
                  <label for="titulo">Titulo</label>
                  <input id="titulo" type="text" class="form-control" v-model="state.titulo" maxlength="120" />
               </div>
               <div class="col-md-4">
                  <label for="destaque">Destaque</label>
                  <select class="form-select" v-model="state.destaque">
                     <option value="SIM">Sim</option>
                     <option value="NAO">Não</option>
                  </select>
               </div>
               <div class="col-md-4">
                  <label for="status">Status</label>
                  <select class="form-select" v-model="state.status">
                     <option value="ATIVO">Ativo</option>
                     <option value="INATIVO">Inativo</option>
                  </select>
               </div>
               <div class="col-md-4">
                  <label for="link">Link para Vídeo</label>
                  <input id="link" type="text" class="form-control" v-model="state.video" maxlength="255" />
               </div>
               <div class="col-md-4">
                  <label for="pagmento">Link para Pagamento</label>
                  <input id="pagmento" type="text" class="form-control" v-model="state.link_pagamento"
                     maxlength="255" />
               </div>
               <div class="col-md-4">
                  <label for="urn">URN</label>
                  <input id="urn" type="text" class="form-control" v-model="state.urn" maxlength="255" />
               </div>
               <div class="col-12">
                  <label for="pagmento">Texto</label>
                  <textarea v-model="state.texto" class="form-control" rows="4"></textarea>
               </div>
               <div class="col-12">
                  <label for="pagmento">Timbres</label>
                  <textarea v-model="state.timbres" class="form-control" rows="4"></textarea>
               </div>
               <div class="col-md-4">
                  <label>Thumbnail</label>
                  <input type="file" class="form-control" @change="adicionarImagem" />
               </div>
               <div style="display: flex" class="col-md-6 offset-md-3 mt-4" v-if="state.imagem.imagem">
                  <img :src="state.imagem.imagem" class="imagem" />
                  <div class="div_btn_x">
                     <button class="btn_remover" @click="removerImagem">
                        <i class="bi bi-x-lg"></i>
                     </button>
                  </div>
               </div>
            </div>
            <div class="d-flex justify-content-end">
               <router-link to="/admin/timbres">
                  <button type="button" class="btn btn-danger me-1">
                     Cancelar
                  </button>
               </router-link>
               <button type="button" @click="upTimbre" class="btn btn-primary"
                  v-if="router.currentRoute._value.params.id">
                  Atualizar
               </button>
               <button type="button" @click="saveTimbre" class="btn btn-success" v-else>
                  Salvar
               </button>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import { useRouter } from "vue-router";
import services from "../../services";
import { onMounted, reactive } from "vue";
import { useStorage } from "vue3-storage";
export default {
   setup() {
      const router = useRouter();
      const state = reactive({
         id: "",
         titulo: "",
         texto: "",
         timbres: "",
         video: "",
         urn: "",
         link_pagamento: "",
         destaque: "",
         status: "",
         imagem: {},
      });

      const storage = useStorage();
      var token = storage.getStorageSync("token");

      onMounted(() => {
         if (router.currentRoute._value.params.id != undefined) {
            fetchTimbre();
         }
      });

      async function fetchTimbre() {
         try {
            const { data } = await services.timbres.getById({
               id: router.currentRoute._value.params.id,
               token,
            });
            state.id = data.id;
            state.urn = data.urn;
            state.titulo = data.titulo;
            state.texto = data.texto;
            state.timbres = data.timbres;
            state.video = data.video;
            state.link_pagamento = data.link_pagamento;
            state.destaque = data.destaque;
            state.status = data.status;
            if (data.thumbnail != null) {
               state.imagem.imagem = data.thumbnail;
            }
         } catch (error) {
        void error;
      }
      }

      async function upTimbre() {
         let dados = new FormData();
         dados.append("id", state.id);
         dados.append("texto", state.texto);
         dados.append("timbres", state.timbres);
         dados.append("urn", state.urn);
         dados.append("titulo", state.titulo);
         dados.append("video", state.video);
         dados.append("link_pagamento", state.link_pagamento);
         dados.append("status", state.status);
         dados.append("destaque", state.destaque);
         if (state.imagem.file != null) {
            dados.append("thumbnail", state.imagem.file);
         }
         dados.append("id", state.id);
         dados.append("_method", "PUT");
         try {
            await services.timbres.update(dados, token);
            router.push("/admin/timbres");
         } catch (error) {
        void error;
      }
      }
      async function saveTimbre() {
         let dados = new FormData();
         dados.append("texto", state.texto);
         dados.append("timbres", state.timbres);
         dados.append("titulo", state.titulo);
         dados.append("video", state.video);
         dados.append("link_pagamento", state.link_pagamento);
         dados.append("urn", state.urn);
         dados.append("status", state.status);
         dados.append("destaque", state.destaque);
         if (state.imagem.file != null) {
            dados.append("thumbnail", state.imagem.file);
         }
         dados.append("id", state.id);
         dados.append("_method", "POST");
         try {
            await services.timbres.save(dados, token);
            router.push("/admin/timbres");
         } catch (error) {
        void error;
      }
      }
      async function adicionarImagem(event) {
         var img = event.target.files[0];
         var objImagem = new Object();
         objImagem.file = img;
         objImagem.imagem = URL.createObjectURL(img);
         state.imagem = objImagem;
      }
      async function removerImagem() {
         state.imagem = {};
         document.querySelector('input[type="file"]').value = null;
      }
      return {
         upTimbre,
         saveTimbre,
         removerImagem,
         adicionarImagem,
         router,
         state,
      };
   },
};
</script>
<style scoped>
h4 {
   color: #fff;
}

label {
   color: #000;
   font-size: 12pt;
   margin-bottom: 0;
   margin-top: 5px;
}

input {
   border: solid 1px #000;
}

textarea {
   border: solid 1px #000;
}

select {
   border: solid 1px #000;
}

.card {
   border: solid 1px #000;
   background-color: #fff;
}

.card-header {
   border-radius: 0px;
   background-color: #000;
   color: #fff;
}

.btn_remover {
   border: none;
   outline: none;
   background-color: #ff0000;
   padding: 5px 10px;
   font-size: 12px;
   font-weight: 700;
   color: #fff;
   border-radius: 5px;
   transition: all ease 0.1s;
   box-shadow: 0px 5px 0px 0px #f57171;
}

.btn_remover:active {
   transform: translateY(5px);
   box-shadow: 0px 0px 0px 0px #f57171;
}

.div_btn_x {
   margin-left: 10px;
}

img {
   width: 100%;
}
</style>